<template>
  <v-dialog
    :value="showDialog"
    @input="closeDialog()"
    content-class="showDialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
    max-width="950px"
    style="z-index: 9999"
  >
    <v-card class="custom-tooltips">
      <v-card-title style="justify-content:center">
        <span class="headline" style="font-size: 1.3rem !important">
          Система здоровья
        </span>
        <v-btn @click="closeDialog()" icon absolute right>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-tabs
        v-model="activetab"
        class="custom-user-tabs"
        centered
        background-color="transparent"
        color="basil"
        grow
        show-arrows
        stacked
      >
        <v-tab>Питание</v-tab>
        <v-tab>Окружение</v-tab>
        <v-tab>Видение</v-tab>
        <v-tab>Мотивация</v-tab>
        <v-tab>Ум</v-tab>
      </v-tabs>
      <v-window v-model="activetab">
        <v-window-item>
          <v-card class="padding-bottom-tooltips">
            <v-card-text ref="modalContentTab1">
              <v-expansion-panels class="add-info-block">
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <h3>
                      <span>Что это?</span>
                      Подробнее...
                    </h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div
                      v-html="getMessage('help_analitycs_food')"
                      class="add-info-block-head-desc"
                    ></div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <div
                v-for="(item, i) in chartBodygraph.food"
                :key="'j' + i"
                outlined
              >
                <span
                  v-html="item.title"
                  class="headline"
                  style="font-size: 1.25rem !important;padding: 15px 0 10px 5px;color: rgba(0, 0, 0, .6);"
                ></span>
                <div v-html="item.tooltip_new"></div>
              </div>
            </v-card-text>
          </v-card>
        </v-window-item>
        <v-window-item>
          <v-card>
            <v-card-text ref="modalContentTab2">
              <v-expansion-panels class="add-info-block">
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <h3>
                      <span>Что это?</span>
                      Подробнее...
                    </h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div
                      v-html="getMessage('help_analitycs_environment')"
                      class="add-info-block-head-desc"
                    ></div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <div
                v-for="(item, i) in chartBodygraph.environment"
                :key="'j' + i"
                outlined
              >
                <span
                  v-html="item.title"
                  class="headline"
                  style="font-size: 1.1rem !important;padding: 15px 0 10px 5px;color: rgba(0, 0, 0, .6);"
                ></span>
                <div v-html="item.tooltip_new"></div>
              </div>
            </v-card-text>
          </v-card>
        </v-window-item>
        <v-window-item>
          <v-card>
            <v-card-text ref="modalContentTab3">
              <v-expansion-panels class="add-info-block">
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <h3>
                      <span>Что это?</span>
                      Подробнее...
                    </h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div
                      v-html="getMessage('help_analitycs_vision')"
                      class="add-info-block-head-desc"
                    ></div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <div
                v-for="(item, i) in chartBodygraph.vision"
                :key="'j' + i"
                outlined
              >
                <span
                  v-html="item.title"
                  class="headline"
                  style="font-size: 1.1rem !important;padding: 15px 0 10px 5px;color: rgba(0, 0, 0, .6);"
                ></span>
                <div v-html="item.tooltip_new"></div>
              </div>
            </v-card-text>
          </v-card>
        </v-window-item>
        <v-window-item>
          <v-card>
            <v-card-text ref="modalContentTab4">
              <v-expansion-panels class="add-info-block">
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <h3>
                      <span>Что это?</span>
                      Подробнее...
                    </h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div
                      v-html="getMessage('help_analitycs_motivation')"
                      class="add-info-block-head-desc"
                    ></div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <div
                v-for="(item, i) in chartBodygraph.motivation"
                :key="'j' + i"
                outlined
              >
                <span
                  v-html="item.title"
                  class="headline"
                  style="font-size: 1.1rem !important;padding: 15px 0 10px 5px;color: rgba(0, 0, 0, .6);"
                ></span>
                <div v-html="item.tooltip_new"></div>
              </div>
            </v-card-text>
          </v-card>
        </v-window-item>
        <v-window-item>
          <v-card>
            <v-card-text>
              <v-expansion-panels class="add-info-block">
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <h3>
                      <span>Что это?</span>
                      Подробнее...
                    </h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div
                      v-html="getMessage('help_analitycs_mind')"
                      class="add-info-block-head-desc"
                    ></div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <div outlined>
                <span
                  v-html="chartBodygraph.mind.title"
                  class="headline"
                  style="font-size: 1.1rem !important;padding: 15px 0 10px 5px;color: rgba(0, 0, 0, .6);"
                ></span>
                <div v-html="chartBodygraph.mind.tooltip_new"></div>
              </div>
            </v-card-text>
          </v-card>
        </v-window-item>
      </v-window>
      <div class="reg-go">
        <div v-html="RegGoTextBeforeBtn"></div>
        <div
          v-if="
            !User.isLogged &&
              $route.path !== '/composite' &&
              $route.path !== '/transit' &&
              $route.path !== '/returns'
          "
          class="flex-center"
        >
          <!-- <v-btn
            @click="callToAppEvents(2)"
            :href="User.tgBotUrl"
            target="_blank"
            v-html="getMessage('btn_tg_tooltip_normal')"
            class="tooltip-btn-bg mob-tooltip-btn-bg"
          ></v-btn>
          &nbsp;&nbsp;
          <v-btn
            @click="clickTooltipBtnBG(extTips)"
            v-html="getMessage(btnTooltipName)"
            class="tooltip-btn-bg mob-tooltip-btn-bg"
          ></v-btn> -->
          <v-btn
            @click="clickTooltipBtnBG(extTips)"
            v-html="getMessage(btnTooltipName)"
            class="tooltip-btn-bg mob-tooltip-btn-bg"
          ></v-btn>
        </div>
        <v-btn
          v-else
          @click="clickTooltipBtnBG(extTips)"
          v-html="getMessage(btnTooltipName)"
          class="tooltip-btn-bg mob-tooltip-btn-bg"
        ></v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { commonInitAppMethods } from "@/mixins/common-init-app-methods";
import { commonReportingMethods } from "@/mixins/common-reporting-methods";

export default {
  name: "PHSTooltipDiaolog",
  mixins: [commonInitAppMethods, commonReportingMethods],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activetab: 0
    };
  },
  computed: {
    ...mapState({
      User: (state) => state.account.User
    }),
    chartBodygraph: {
      get() {
        return this.$store.state.account.User.chartBodygraph;
      },
      set(value) {
        this.$store.commit("get_body_graph", value);
      }
    },
    firstname: {
      get() {
        return this.$store.state.account.User.name;
      },
      set(value) {
        this.$store.commit("account/update_first_name", value);
      }
    },
    RegGoTextBeforeBtn() {
      return this.$route.path === "/bodygraph" ||
        this.$route.path === "/transit" ||
        this.$route.path === "/returns"
        ? this.$store.state.account.User.RegGoTextBeforeBtn
        : this.$route.path === "/composite"
        ? this.$store.state.account.User.RegGoTextBeforeBtnComposite
        : "";
    },
    btnTooltipName() {
      return this.$route.path === "/bodygraph" ||
        this.$route.path === "/transit" ||
        this.$route.path === "/returns"
        ? this.$store.state.account.User.btnTooltipName
        : this.$route.path === "/composite"
        ? this.$store.state.account.User.btnTooltipNameComposite
        : "";
    },
    extTips() {
      return this.$store.state.conf.ConfApp.isBuyedProTooltips;
    }
  },
  beforeMount() {
    window.openLoginDialog = this.openLoginDialog;
  },
  methods: {
    ...mapMutations({
      update_login_dialog: "conf/update_login_dialog"
    }),
    clickTooltipBtnBG(extTips, isInfoBlockExtTips) {
      if (this.$route.path === "/bodygraph") {
        const SHOP_URL =
          extTips === "ext_tips"
            ? this.$store.state.conf.ConfApp.tooltips_buy_full_url
            : extTips
            ? this.$store.state.conf.ConfApp.tooltips_shop_url
            : this.$store.state.conf.ConfApp.tooltips_sale_shop_url;
        switch (this.$store.state.conf.ConfApp.tooltip_button_type) {
          case 1:
            if (isInfoBlockExtTips) {
              const URL = SHOP_URL + "&tag=r" + this.User.reportid;
              window.open(URL, "_blank");
            } else {
              this.closeDialog();
              this.update_login_dialog(true);
            }
            break;
          case 2:
            this.$router.push("/profile");
            break;
          case 3: {
            // this.$router.push("/products");
            const URL3 = this.$store.state.conf.ConfApp.pdfs_shop_url;
            window.open(URL3, "_blank");
            break;
          }
          case 4: {
            const URL4 = SHOP_URL + "&tag=r" + this.User.reportid;
            window.open(URL4, "_blank");
            break;
          }
          case 6: {
            // Здесь сейчас показываются всегда FULL-подсказки
            const SHOP_URL6 = this.$store.state.conf.ConfApp
              .tooltips_buy_full_url;
            const URL6 = SHOP_URL6 + "&tag=r" + this.User.reportid;
            window.open(URL6, "_blank");
            break;
          }
          case 7:
            // FULL-подсказки выключены, предложение включить
            this.$router.push("/profile");
            break;
          case 8: {
            // Если приходит 8, то в бодиграфе предлагаются демо-расшифровки
            const url8 = this.$store.state.conf.ConfApp.demo_report_shop_url;
            window.open(url8, "_blank");
            break;
          }
          case 9: {
            // Если приходит 9, то в бодиграфе предлагается купить 1 демо-расшифровку
            const url9 =
              this.$store.state.conf.ConfApp.one_report_tooltips_url +
              "&tag=r" +
              this.User.reportid;
            window.open(url9, "_blank");
            break;
          }
          default:
            this.$store.commit(
              "account/set_partner_info_text",
              this.getMessage("partners")
            );
            this.$store.commit("account/call_partner_dialog");
            break;
        }
      } else if (this.$route.path === "/composite") {
        switch (this.$store.state.conf.ConfApp.cp_tooltip_button_type) {
          case 1:
            this.update_login_dialog(true);
            break;
          case 2:
            this.$router.push("/profile");
            break;
          case 3:
            this.$router.push("/products");
            break;
          case 4: {
            const SHOP_URL4 = extTips
              ? this.$store.state.conf.ConfApp.tooltips_shop_url
              : this.$store.state.conf.ConfApp.tooltips_sale_shop_url;
            const url4 = SHOP_URL4 + "&tag=r" + this.User.reportid;
            window.open(url4, "_blank");
            break;
          }
          case 5: {
            const url5 =
              this.$store.state.conf.ConfApp.composite_shop_url +
              "&tag=r" +
              this.User.reportid;
            window.open(url5, "_blank");
            break;
          }
          case 6: {
            /* const SHOP_URL6 =
                extTips ||
                extTips === 'ext_tips' ||
                this.User.full_tooltips_count
                  ? this.$store.state.ConfApp.tooltips_buy_full_url
                  : this.$store.state.ConfApp.tooltips_shop_url */
            // Если приходит 6, то в композите предлагаются только расширенные
            const SHOP_URL6 = this.$store.state.conf.ConfApp
              .tooltips_buy_full_url;
            const url6 = SHOP_URL6 + "&tag=r" + this.User.reportid;
            window.open(url6, "_blank");
            break;
          }
          case 7:
            // FULL-подсказки выключены, предложение включить
            this.$router.push("/profile");
            break;
          case 8: {
            // Если приходит 8, то в бодиграфе предлагаются демо-расшифровки
            const url8 = this.$store.state.conf.ConfApp.demo_report_shop_url;
            window.open(url8, "_blank");
            break;
          }
          default:
            this.$store.commit(
              "account/set_partner_info_text",
              this.getMessage("partners")
            );
            this.$store.commit("account/call_partner_dialog");
            break;
        }
      } else if (
        this.$route.path === "/transit" ||
        this.$route.path === "/returns"
      ) {
        /* console.log(
          "tooltip_button_type: ",
          this.$store.state.conf.ConfApp.tooltip_button_type
        ); */
        switch (this.$store.state.conf.ConfApp.tooltip_button_type) {
          case 1: {
            // this.closeDialog();
            // this.update_login_dialog(true);
            // Hardcode — предлагается PDF-отчет
            const URL = this.$store.state.conf.ConfApp.pdfs_shop_url;
            window.open(URL, "_blank");
            break;
          }
          case 2:
            this.$router.push("/profile");
            break;
          case 3:
            this.$router.push("/products");
            break;
          case 4: {
            const SHOP_URL4 = extTips
              ? this.$store.state.conf.ConfApp.tooltips_shop_url
              : this.$store.state.conf.ConfApp.tooltips_sale_shop_url;
            const url4 = SHOP_URL4 + "&tag=r" + this.User.reportid;
            window.open(url4, "_blank");
            break;
          }
          case 5: {
            const url5 =
              this.$store.state.conf.ConfApp.composite_shop_url +
              "&tag=r" +
              this.User.reportid;
            window.open(url5, "_blank");
            break;
          }
          case 6: {
            // Если приходит 6, то предлагаются PDF-отчет
            const SHOP_URL6 = this.$store.state.conf.ConfApp.tooltips_shop_url;
            const url6 = SHOP_URL6 + "&tag=r" + this.User.reportid;
            window.open(url6, "_blank");
            break;
          }
          case 7:
            // FULL-подсказки выключены, предложение включить
            this.$router.push("/profile");
            break;
          case 8: {
            // Если приходит 8, то в бодиграфе предлагаются демо-расшифровки
            const url8 = this.$store.state.conf.ConfApp.demo_report_shop_url;
            window.open(url8, "_blank");
            break;
          }
          default:
            if (this.User.isLogged) {
              // реклама партнерки по дифолту (отключена)
              /* this.$store.commit(
                "account/set_partner_info_text",
                this.getMessage("partners")
              );
              this.$store.commit("account/call_partner_dialog"); */
              // по дифолту для авторизованных юзеров сейчас переход на покупку PDF
              const URL = this.$store.state.conf.ConfApp.pdfs_shop_url;
              window.open(URL, "_blank");
            } else {
              this.closeDialog();
              this.update_login_dialog(true);
            }
            break;
        }
      }
    },
    openLoginDialog() {
      this.update_login_dialog(true);
    },
    closeDialog() {
      if (this.$refs.modalContentTab1)
        this.$refs.modalContentTab1.scrollTop = 0;
      if (this.$refs.modalContentTab2)
        this.$refs.modalContentTab2.scrollTop = 0;
      if (this.$refs.modalContentTab3)
        this.$refs.modalContentTab3.scrollTop = 0;
      if (this.$refs.modalContentTab4)
        this.$refs.modalContentTab4.scrollTop = 0;
      this.activetab = null;
      this.$emit("closePHSDialog");
    }
  }
};
</script>
<style scoped>
.custom-user-tabs.v-tabs {
  flex: initial;
}
.v-window.v-item-group {
  overflow-y: auto;
}
</style>
